// extracted by mini-css-extract-plugin
module.exports = {"color":"s_color__yJqf6","wrap":"s_wrap__1cXj-"};